import React from "react";
import PropTypes from "prop-types";
import lodash from "lodash";
import moment from "moment";
import ReactTooltip from "react-tooltip";

import NotesModal from "./NotesModal";

function checkedIn(data) {
  return data && data.check_in_at ?
    moment(new Date(data.check_in_at)).format("MM/DD/YYYY h:mm a") :
    "";
}

class Cell extends React.Component {
  state = { visibleNote: false };

  get employeeSkill() {
    const { employee, skill, employeesSkills } = this.props;
    return lodash.find(employeesSkills, {
      user_id: employee.id, in_service_category_skill_id: skill.id
    });
  }

  get checked() {
    const employeeSkill = this.employeeSkill;
    return employeeSkill ? employeeSkill.status : false;
  }

  get notes() {
    const employeeSkill = this.employeeSkill;
    return employeeSkill ? employeeSkill.notes : "";
  }

  toggle = e => {
    const { employee, skill, onUpdate } = this.props;
    onUpdate(employee.id, skill.id, { status: e.target.checked, notes: this.notes });
  };

  handleUpdateNote = text => {
    const { employee, skill, onUpdate } = this.props;
    onUpdate(employee.id, skill.id, { status: this.checked, notes: text });

    this.toggleNote();
  };

  toggleNote = () => this.setState({ visibleNote: !this.state.visibleNote });

  render() {
    const { visibleNote } = this.state;
    const { isEdit } = this.props;
    const checked = this.checked;
    const notes = this.notes;

    return (
      <td className="text-center">
        {isEdit ? (
          <div>
            <a className="pull-right" href="javascript:void(0);" onClick={this.toggleNote}>
              <i className="material-icons md-15 icon-for-dropdown">chat</i>
            </a>
            <NotesModal
              visible={visibleNote}
              notes={this.notes}
              onClose={this.toggleNote}
              onDone={this.handleUpdateNote}
            />

            <input
              type="checkbox"
              style={{ width: "auto" }}
              checked={checked}
              onChange={this.toggle}
            />
          </div>
        ) : checked === null ? "" : (
          <div>
            {checked ?
              <i className="material-icons">done</i> :
              null
            }

            {notes ? (
              <span className="pull-right">
                <span data-tip={notes}>
                  <i className="material-icons md-15 icon-for-dropdown">chat</i>
                  <ReactTooltip/>
                </span>
              </span>
            ) : null}
          </div>
        )}
      </td>
    );
  }
}

const Employee = ({
  isAdmin,
  isEdit,
  employee,
  employeesSkills,
  skills,
  inServiceUser,
  onUpdate,
  onCheckAll,
  onDelete,
  onOpenSignatureModal
}) => (
  <tr>
    {isEdit ? (
      <td>
        <a
          href="javascript:void(0);"
          onClick={() => { onCheckAll(employee.id) }}
        >
          <i className="material-icons">done_all</i>
        </a>
      </td>
    ) : null}
    <td className="row-header">
      <div className="wrapper">
        {employee.full_name_reverse}
        {isAdmin ? (
          <a href="javascript:void(0);" onClick={() => { onDelete(employee.id) }}>
            <i className="material-icons pink">delete</i>
          </a>
        ) : null}
      </div>
    </td>
    {isAdmin ? (
      <td>
        {checkedIn(inServiceUser)}
      </td>
    ) : null}
    {isAdmin ? (
      <td>
        { inServiceUser && inServiceUser.signature && inServiceUser.signature.image_url &&
          <a href="javascript:void(0);" onClick={() => { onOpenSignatureModal(inServiceUser.signature.image_url) }}>
            View
          </a>
        }
      </td>
    ) : null}
    {skills.map(skill =>
      <Cell
        key={skill.id}
        isEdit={isEdit}
        skill={skill}
        employee={employee}
        employeesSkills={employeesSkills}
        onUpdate={onUpdate}
      />
    )}
  </tr>
);

Cell.propTypes = {
  isEdit: PropTypes.bool.isRequired,
  employee: PropTypes.object.isRequired,
  employeesSkills: PropTypes.array.isRequired,
  skill: PropTypes.object.isRequired,
  onUpdate: PropTypes.func
};

Employee.propTypes = {
  isEdit: PropTypes.bool.isRequired,
  employee: PropTypes.object.isRequired,
  employeesSkills: PropTypes.array.isRequired,
  skills: PropTypes.array.isRequired,
  inServiceUser: PropTypes.object,
  onUpdate: PropTypes.func.isRequired,
  onCheckAll: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onOpenSignatureModal: PropTypes.func
};

export default Employee;
